<template>
  <tr :class="classRow()" @click="clickRow" @dblclick="dblclickRow" @contextmenu="contextMenuRow">
    <template v-if="row._slot && row._slot.length > 0">
      <td :colspan="colspan">
        <slot :name="row._slot" />
      </td>
    </template>

    <template v-else>
      <slot name="item" :item="row" :headers="headersExibicao">
        <td
          v-if="showSelect"
          key="data-table-select"
          id="column-first"
          :style="styleColunm(headerColumnSelect)"
        >
          <slot name="item.data-table-select-td" :isSelecded="itemSelected" :isSelected="itemSelected" :item="row" :select="select">
            <div class="cursor-pointer" @click.stop="select">
              <slot name="item.data-table-select" :isSelecded="itemSelected" :isSelected="itemSelected" :item="row">
                <v-icon v-if="itemSelected" :color="colorShowSelect">mdi-checkbox-marked</v-icon>
                <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
              </slot>
            </div>
          </slot>
        </td>

        <td v-if="showExpand" key="data-table-expand" :style="styleColunm()">
          <div class="cursor-pointer" @click.stop="expand">
            <slot name="item.data-table-expand" :isExpanded="itemExpanded">
              <v-icon v-if="itemExpanded">mdi-chevron-up</v-icon>
              <v-icon v-else>mdi-chevron-down</v-icon>
            </slot>
          </div>
        </td>

        <td
          v-for="header in headersExibicao"
          :key="header.value"
          :style="styleColunm(header)"
          :class="{
            'column-drag': column_drag.value === header.value
          }"
          @contextmenu="ev => $emit('contextmenu:column', {ev, row, header})"
        >
          <slot
            :name="`item.${header.value}`"
            :item="row"
            :value="row[header.value]"
            :header="header"
            :headers="headersExibicao"
            :isExpanded="itemExpanded"
            :expand="expand"
          >
            <template v-if="header.prefix">
              {{ header.prefix }}
            </template>

            <template v-if="header.is_number">
              {{ Helpers.formatarValor(row[header.value]) }}
            </template>

            <template v-else-if="header.is_money">
              {{ Helpers.formatarValorMonetario(row[header.value]) }}
            </template>

            <template v-else>
              {{row[header.value] || ''}}
            </template>

            <template v-if="header.sufix">
              {{ header.sufix }}
            </template>
          </slot>
        </td>

        <td v-if="showColumnCustom"></td>
      </slot>
    </template>
  </tr>
</template>

<script>
import Mixin from "./Mixin";
import indexProps from "./IndexProps";

export default {
  name: "Row",
  inject: ["itemKey"],
  mixins: [Mixin],
  props: {
    headers: Array,
    row: {
      type: Object,
      required: true
    },
    arrayItemKeySelected: Array,
    itemHeight: indexProps.itemHeight,
    itemClass: indexProps.itemClass,
    showExpand: indexProps.showExpand,
    colorShowSelect: indexProps.colorShowSelect,
    itens_expandidos: Array,
    hideBorderBottomTr: indexProps.hideBorderBottomTr,
    showSelect: indexProps.showSelect,
    column_drag: Object,
    showColumnCustom: indexProps.showColumnCustom,
  },
  computed: {
    itemSelected() {
      return this.arrayItemKeySelected.includes(this.row[this.itemKey]);
    },
    itemExpanded() {
      return this.itens_expandidos.includes(this.row);
    },
    headerColumnSelect() {
      return this.headers.find(item => item.value === 'data-table-select') || {};
    },
    headersExibicao() {
      return this.headers.filter(header =>
        header.value !== 'data-table-select' &&
        header.visible !== false
      );
    }
  },
  methods: {
    styleColunm(header = {}) {
      return {
        borderBottom: this.hideBorderBottomTr ? false : '1px solid #e1dfdf',
        ...(header.style || {}),
        height: `${this.itemHeight}px`,
      }
    },
    select() {
      this.$emit("item-selected", this.row)
    },
    expand() {
      this.$emit("item-expanded", this.row)
    },
    classRow() {
      if (typeof this.itemClass === 'function') {
        return this.itemClass(this.row);
      }

      return this.itemClass;
    },
    clickRow() {
      const ev = {
        row: this.row,
        expand: this.expand,
        isExpanded: this.itemExpanded
      }
      this.$emit('click:row', ev);
    },
    dblclickRow() {
      const ev = {
        row: this.row,
        expand: this.expand,
        isExpanded: this.itemExpanded
      }
      this.$emit('dblclickRow:row', ev);
    },
    contextMenuRow(evento_padrao) {
      const ev = {
        row: this.row,
        expand: this.expand,
        isExpanded: this.itemExpanded,
        evento_padrao: evento_padrao
      }
      this.$emit('contextmenu:row', ev);
    }
  }
}
</script>

<style scoped>
#column-first {
  width: 30px;
}
tr td {
  font-size: 12px;
  padding: 0 4px;
}
.column-drag {
  background: #f0f6ff !important;
  border-left: 2px dashed #5983c3 !important;
  border-right: 2px dashed #5983c3 !important;
}
</style>
